$(document).ready(function () {
  // ====================== Product Review ======================
  $("#shopify-product-reviews").append($(".jdgm-rev-widg__body"));
  $(".jdgm-prev-badge").insertAfter($(".product-info"));
  $("#judgeme_product_reviews").insertBefore($("#shopify-product-reviews"));
  $(".jdgm-write-rev-link.jdgm-write-rev-link").addClass("btn");

  // ====================== Newsletter Popup ======================
  $("#newsletterModal .close").click(function () {
    $("#newsletterModal").addClass("d-none");
    $(".modal-backdrop").addClass("d-none");
  });

  // ====================== Error & Success Modal ======================
  $(".ajax-error-modal .modal-inner .close").click(function () {
    $(".ajax-error-modal").addClass("d-none");
  });
  $(".ajax-success-modal .content .added-to-cart.info .close").click(
    function () {
      $(".ajax-success-modal .content .added-to-cart.info").addClass("d-none");
    }
  );

  // ====================== Navbar Toggle ======================
  jQuery(".nav-toggle").click(function (event) {
    jQuery(this).toggleClass("active");
    event.stopPropagation();
    jQuery(" #tb-megamenu .tb-mega_menu").slideToggle("2000");
  });
  jQuery("#tb-megamenu .tb-mega_menu").on("click", function (event) {
    event.stopPropagation();
    jQuery(this).removeClass("active");
  });

  // ====================== Filter Toggle ======================
  jQuery(".filter-toggle").on("click", function (e) {
    e.preventDefault();
    jQuery(this).toggleClass("active");
    jQuery(".filter-toggle-wrap").slideToggle("is-visible");
  });
  var filter = jQuery(this).find(".full_width .sorting_wrapper");
  jQuery(this).find(".filter-toggle").insertBefore(filter);

  /*---------------- End Blog UP/Down JS  ---------------- */
  /* style1 product_thumb_image*/
  jQuery(".product-single__thumbs a").on("click", function () {
    var src = jQuery(this).data("fullsrc");

    if (src != "") {
      jQuery(this)
        .closest(".product-wrapper")
        .find("img.grid-view-item__image")
        .first()
        .attr("src", src);
    }
    jQuery(this)
      .parent(".grid-item")
      .addClass("open")
      .siblings(".grid-item")
      .removeClass("open");
  });

  /*---------------- Start Blog UP/Down JS  ---------------- */

  jQuery(".collection_cms_slider .wrapp-category:odd").addClass("odd");
  jQuery(".collection_cms_slider .wrapp-category:even").addClass("even");

  jQuery(
    ".collection_cms_slider .wrapp-category.odd .collection_cat_item"
  ).each(function (index, element) {
    var html = "";
    html +=
      '<div class="tb-collection-content right-block">' +
      jQuery(element).find(".right-block").html() +
      "</div>";
    html +=
      '<div class="collection_img left-block">' +
      jQuery(element).find(".left-block").html() +
      "</div>";
    jQuery(element).html(html);
  });

  /*---------------- End Blog UP/Down JS  ---------------- */

  //video
  var p = jQuery(".popup_overlay");

  jQuery("#popup_toggle").click(function () {
    jQuery("body").addClass("popup-toggle");
    p.css("display", "block");
  });
  p.click(function (event) {
    e = event || window.event;
    if (e.target == this) {
      jQuery(p).css("display", "none");
      jQuery("body").removeClass("popup-toggle");
    }
  });
  jQuery(".popup_close").click(function () {
    p.css("display", "none");
    jQuery("body").removeClass("popup-toggle");
  });

  //video popup
  function toggleVideo(state) {
    // if state == 'hide', hide. Else: show video
    var div = document.getElementById("popupVid");
    var iframe = div.getElementsByTagName("iframe")[0].contentWindow;
    //div.style.display = state == 'hide' ? 'none' : '';
    func = state == "hide" ? "pauseVideo" : "playVideo";
    iframe.postMessage(
      '{"event":"command","func":"' + func + '","args":""}',
      "*"
    );
  }

  jQuery("#popup_toggle").click(function () {
    p.css("visibility", "visible").css("opacity", "1");
  });

  p.click(function (event) {
    e = event || window.event;
    if (e.target == this) {
      jQuery(p).css("visibility", "hidden").css("opacity", "0");
      toggleVideo("hide");
    }
  });

  jQuery(".popup_close").click(function () {
    p.css("visibility", "hidden").css("opacity", "0");
    toggleVideo("hide");
  });

  //filter

  if (jQuery(".header_3.site-header").hasClass("disable_menutoggle")) {
    jQuery("body").addClass("disable_menutoggle");
    if (jQuery(".header_3.site-header").hasClass("menu_left")) {
      jQuery("body").addClass("menu_left");
    }
    if (jQuery(".header_3.site-header").hasClass("menu_right")) {
      jQuery("body").addClass("menu_right");
    }
  }
  if (jQuery(".header_1 .wrapper-wrap").hasClass("logo_center")) {
    jQuery("body").addClass("logo_center");
  }
  var w_width = $(window).width();
  $(".slider-content-main-wrap").css("width", w_width);
  if ($(".site-header").hasClass("header_transaparent")) {
    $("body.template-index").addClass("header_transaparent");
  }

  $(".header_1 .mini-cart-wrap,.header_3 .mini-cart-wrap").perfectScrollbar();

  var img_id = jQuery(".product-single__thumbs .slick-active.slick-current")
    .find(".product-single__thumb")
    .data("id");
  if (jQuery(".product-lightbox-btn").hasClass(img_id)) {
    jQuery(".product-lightbox-btn." + img_id).show();
  }

  jQuery(".filter-left").on("click", function (e) {
    e.preventDefault();
    jQuery(this).toggleClass("active");
    jQuery(".off-canvas.position-left").addClass("is-open");
    jQuery(".js-off-canvas-overlay.is-overlay-fixed").addClass(
      "is-visible is-closable"
    );
  });
  jQuery(".filter-right").on("click", function (e) {
    e.preventDefault();
    jQuery(this).toggleClass("active");
    jQuery(".off-canvas.position-right").addClass("is-open");
    jQuery(".js-off-canvas-overlay.is-overlay-fixed").addClass(
      "is-visible is-closable"
    );
  });
  jQuery(".off-canvas .sidebar_close").on("click", function (e) {
    e.preventDefault();
    jQuery(".off-canvas.position-left").removeClass("is-open");
    jQuery(".off-canvas.position-right").removeClass("is-open");
    jQuery(".js-off-canvas-overlay.is-overlay-fixed").removeClass(
      "is-visible is-closable"
    );
  });
  jQuery(".is-overlay-fixed").on("click", function (e) {
    e.preventDefault();
    jQuery(".filter-left").trigger("click");
    jQuery(".filter-right").trigger("click");
    jQuery(".off-canvas.position-left").removeClass("is-open");
    jQuery(".off-canvas.position-right").removeClass("is-open");
    jQuery(".js-off-canvas-overlay.is-overlay-fixed").removeClass(
      "is-visible is-closable"
    );
  });
  $(".product-360-button a").magnificPopup({
    type: "inline",
    mainClass: "mfp-fade",
    removalDelay: 160,
    disableOn: false,
    preloader: false,
    fixedContentPos: false,
    callbacks: {
      open: function () {
        $(window).resize();
      },
    },
  });

  countDownIni(".flip-countdown,.js-flip-countdown");

  /** popup Video **/

  $(".popup-video").magnificPopup({
    disableOn: 300,
    type: "iframe",
    mainClass: "mfp-fade",
    removalDelay: 160,
    preloader: false,
    fixedContentPos: false,
  });

  /***/

  if (
    $("a.product-lightbox-btn").length > 0 ||
    $("a.product-video-popup").length > 0
  ) {
    $(".product-single__photos .gallery,.design_2 .product-img").magnificPopup({
      delegate: "a", // child items selector, by clicking on it popup will open
      type: "image",
      tLoading:
        '<div class="please-wait dark"><span></span><span></span><span></span></div>',
      removalDelay: 300,
      closeOnContentClick: true,
      gallery: {
        enabled: true,
        navigateByImgClick: false,
        preload: [0, 1],
      },
      image: {
        verticalFit: false,
        tError: '<a href="%url%">The image #%curr%</a> could not be loaded.',
      },
      callbacks: {
        beforeOpen: function () {
          var productVideo = $(".product-video-popup").attr("href");
          if (productVideo) {
            this.st.mainClass = "has-product-video";
            var galeryPopup = $.magnificPopup.instance;
            galeryPopup.items.push({
              src: productVideo,
              type: "iframe",
            });
            galeryPopup.updateItemHTML();
          }
        },
        open: function () {},
      },
      // other options
    });
  }
  $(".design_3 .product-img,.design_5 .pro_img").magnificPopup({
    delegate: "a", // child items selector, by clicking on it popup will open
    type: "image",
    tLoading:
      '<div class="please-wait dark"><span></span><span></span><span></span></div>',
    removalDelay: 300,
    closeOnContentClick: true,
    gallery: {
      enabled: true,
      navigateByImgClick: false,
      preload: [0, 1],
    },
    image: {
      verticalFit: false,
      tError: '<a href="%url%">The image #%curr%</a> could not be loaded.',
    },
    callbacks: {
      beforeOpen: function () {
        var productVideo = $(".product-video-popup").attr("href");
        if (productVideo) {
          this.st.mainClass = "has-product-video";
          var galeryPopup = $.magnificPopup.instance;
          galeryPopup.items.push({
            src: productVideo,
            type: "iframe",
          });
          galeryPopup.updateItemHTML();
        }
      },
      open: function () {},
    },
    // other options
  });
  $("body").on("click", ".product-lightbox-btn", function (e) {
    $(".product-wrapper-owlslider").find(".owl-item.active a").click();
    e.preventDefault();
  });

  if (jQuery(window).width() >= 992) {
    jQuery(".header_1 .fullscreen_header_toggle").on("click", function (e) {
      jQuery(this).toggleClass("active");
      jQuery("#tb-megamenu").slideToggle("slow");
      jQuery("body").toggleClass("fullnav-open header_1");
      e.preventDefault();
    });
  }
  jQuery(".header_style_3 .header_3_toggle").on("click", function (e) {
    jQuery(".header_style_3").toggleClass("header_3_toggle_active");
  });
  jQuery(".header_3 .fullscreen_header_toggle").on("click", function (e) {
    e.preventDefault();
    jQuery(this).toggleClass("active");
    jQuery("#tb-megamenu").toggleClass("active");
    jQuery(".fullscreen_header").toggleClass("nav-open");
    jQuery("body").toggleClass("fullnav-open header_3");
  });
  jQuery(".menu-close,.header_style_3 #shopify-section-TB-megamenu").on(
    "click",
    function (e) {
      e.preventDefault();
      jQuery("#tb-megamenu").removeClass("active");
      jQuery("body").removeClass("fullnav-open header_3");
      jQuery(".header_3 .fullscreen_header_toggle").removeClass("active");
    }
  );
  /* start vertical js*/
  if (jQuery(".leftmenu_header").length > 0) {
    if (jQuery(".header_3 .leftmenu_header").length > 0) {
      if (jQuery(".header_3 .leftmenu_header").hasClass("menu_left")) {
        jQuery("body").addClass("menu_left");
      }
      if (jQuery(".header_3 .leftmenu_header").hasClass("menu_right")) {
        jQuery("body").addClass("menu_right");
      }
    } else if (jQuery(".leftmenu_header_fixed.leftmenu_header").length > 0) {
      if (
        jQuery(".leftmenu_header_fixed.leftmenu_header").hasClass("menu_left")
      ) {
        jQuery("body").addClass("menu_left");
      }
      if (
        jQuery(".leftmenu_header_fixed.leftmenu_header").hasClass("menu_right")
      ) {
        jQuery("body").addClass("menu_right");
      }
    } else {
      if (jQuery(".header_3 .leftmenu_header").parent().hasClass("menu_left")) {
        jQuery("body").addClass("menu_left");
      }
      if (jQuery(".header_3 .leftmenu_header").hasClass("menu_right")) {
        jQuery("body").addClass("menu_right");
      }
    }
    jQuery(".leftmenu_header").on("click", function (e) {
      e.preventDefault();
      jQuery(this).toggleClass("active");
      jQuery("body").toggleClass("nav-open");
    });
  }

  /* end vertical js*/

  $(".qtyplus").on("click", function (e) {
    e.preventDefault();
    var input_val = jQuery(this).parents(".qty-box-set").find(".quantity");
    var currentVal = parseInt(
      jQuery(this).parents(".qty-box-set").find(".quantity").val()
    );
    if (!isNaN(currentVal)) {
      jQuery(this)
        .parents(".qty-box-set")
        .find(".quantity")
        .val(currentVal + 1);
    } else {
      jQuery(this).parents(".qty-box-set").find(".quantity").val(1);
    }
  });

  $(".qtyminus").on("click", function (e) {
    e.preventDefault();
    var input_val = jQuery(this).parents(".qty-box-set").find(".quantity");
    var currentVal = parseInt(
      jQuery(this).parents(".qty-box-set").find(".quantity").val()
    );
    if (!isNaN(currentVal) && currentVal > 1) {
      jQuery(this)
        .parents(".qty-box-set")
        .find(".quantity")
        .val(currentVal - 1);
    } else {
      jQuery(this).parents(".qty-box-set").find(".quantity").val(1);
    }
  });
  $("#navToggle").on("click", function (e) {
    jQuery(this).next(".Site-navigation").slideToggle(500);
  });
  $(".menu_toggle_wrap #navToggle").on("click", function (e) {
    jQuery(this).parent().next(".Site-navigation").slideToggle(500);
  });

  /*Scroll to top js*/
  jQuery("#GotoTop").on("click", function () {
    jQuery("html, body").animate(
      {
        scrollTop: 0,
      },
      "1000"
    );
    return false;
  });

  jQuery(".site-header__search.search-full .serach_icon").on(
    "click",
    function (e) {
      e.preventDefault();
      jQuery(this).toggleClass("active");
      jQuery("body").toggleClass("search_full_active");
      jQuery(".full-search-wrapper").addClass("search-overlap");
      jQuery(".header_3 .search-full-screen").addClass("active");
      jQuery(".search-bar > input").focus();
      jQuery(".customer_account").slideUp("fast");
      jQuery("#slidedown-cart").slideUp("fast");
      jQuery("#Sticky-slidedown-cart").slideUp("fast");
    }
  );
  jQuery(".site-header__search.search-full .close-search").on(
    "click",
    function () {
      jQuery(".site-header__search.search-full .serach_icon").removeClass(
        "active"
      );
      jQuery(".full-search-wrapper").removeClass("search-overlap");
      jQuery(".header_3 .search-full-screen").removeClass("active");
      jQuery("body").removeClass("search_full_active");
      jQuery("body").removeClass("myaccount_active");
      jQuery("body").removeClass("cart_active");
    }
  );

  jQuery(".site-header__search:not(.search-full) .serach_icon").on(
    "click",
    function () {
      jQuery("body").toggleClass("search-open");
      jQuery("body").removeClass("myaccount_active");
      jQuery("body").removeClass("cart_active");
      jQuery(".search_wrapper").slideToggle("fast");
      jQuery(".search-bar > input").focus();
      jQuery(this).toggleClass("active");
      jQuery(".site-header .site-header_cart_link").removeClass("active");
      jQuery(".customer_account").slideUp("fast");
      jQuery("#slidedown-cart").slideUp("fast");
      jQuery("#Sticky-slidedown-cart").slideUp("fast");
    }
  );
  jQuery(".myaccount .dropdown-toggle").on("click", function (event) {
    event.preventDefault();
    jQuery("body").toggleClass("myaccount_active");
    jQuery("body").removeClass("search-open");
    jQuery("body").removeClass("cart_active");
    if ($(".currency-block")[0]) {
      $(".currency-block > ul").css("display", "none");
      $(".header_currency .currency_wrapper.dropdown-toggle").removeClass(
        "active"
      );
    }

    jQuery(
      ".header_1 .customer_account,.header_2 .customer_account,.header_3 .customer_account"
    ).slideToggle("fast");
    jQuery(this).toggleClass("open");
    jQuery(".site-header__search:not(.search-full) .serach_icon").removeClass(
      "active"
    );
    jQuery("body").removeClass("search_full_active");
    jQuery(".site-header .site-header_cart_link").removeClass("active");
    jQuery(".site-header .search_wrapper").slideUp("fast");
    jQuery("#slidedown-cart").slideUp("fast");
    jQuery("#Sticky-slidedown-cart").slideUp("fast");
  });

  $(".header_currency .currency_wrapper.dropdown-toggle").on(
    "click",
    function (event) {
      event.preventDefault();
      jQuery(".customer_account").stop();
      jQuery(".currencies.flag-dropdown-menu").slideToggle("fast");
      $(this).toggleClass("active");
    }
  );
  var p_col = jQuery(".slider-newproduct").data("col");
  if (jQuery("body").hasClass("disable_menutoggle")) {
    $("body.disable_menutoggle .slider-newproduct").owlCarousel({
      items: p_col, //10 items above 1000px browser width
      nav: true,
      dots: false,
      // rewind:true,
      responsive: {
        100: {
          items: 1,
        },
        320: {
          items: 2,
        },
        768: {
          items: 2,
        },
        992: {
          items: 3,
        },
        1200: {
          items: p_col,
        },
      },
    });
  } else {
    $("body .slider-newproduct").owlCarousel({
      items: p_col, //10 items above 1000px browser width
      nav: true,
      dots: false,
      // rewind:true,
      responsive: {
        100: {
          items: 1,
        },
        320: {
          items: 2,
        },
        768: {
          items: 2,
        },
        992: {
          items: 2,
        },
        1200: {
          items: p_col,
        },
      },
    });
  }

  $(".slider-newproduct-wrap").each(function () {
    if ($(this).find(".owl-nav").hasClass("disabled")) {
      $(this).find(".customNavigation").hide();
    } else {
      $(this).find(".customNavigation").show();
    }
  });
  $(".slider-newproduct-wrap .customNavigation .next").click(function () {
    var wrap = $(this).closest(".slider-newproduct-wrap");
    $(wrap).find(".slider-newproduct").trigger("next.owl");
  });
  $(".slider-newproduct-wrap .customNavigation .prev").click(function () {
    var wrap = $(this).closest(".slider-newproduct-wrap");
    $(wrap).find(".slider-newproduct").trigger("prev.owl");
  });
  var brandsowl = $("body:not(.rtl) #brands_list_slider");
  var brandsowlrtl = $("body.rtl #brands_list_slider");
  brandsowl.owlCarousel({
    items: 5, //10 items above 1000px browser width
    dots: false,
    // rewind:true,
    autoplay: true,
    autoplayHoverPause: true,
    nav: true,
    responsive: {
      100: {
        items: 2,
      },
      320: {
        items: 2,
      },
      544: {
        items: 3,
      },
      992: {
        items: 4,
      },
      1200: {
        items: 5,
      },
    },
  });
  brandsowlrtl.owlCarousel({
    items: 5, //10 items above 1000px browser width
    dots: false,
    rewind: true,
    nav: true,
    autoplay: true,
    autoplayHoverPause: true,
    rtl: true,
    responsive: {
      100: {
        items: 2,
      },
      320: {
        items: 2,
      },
      544: {
        items: 3,
      },
      992: {
        items: 4,
      },
      1200: {
        items: 5,
      },
    },
  });
  $(".brands_next").click(function () {
    brandsowl.trigger("owl.next");
  });
  $(".brands_prev").click(function () {
    brandsowl.trigger("owl.prev");
  });
  $(".brands_next").click(function () {
    brandsowlrtl.trigger("owl.next");
  });
  $(".brands_prev").click(function () {
    brandsowlrtl.trigger("owl.prev");
  });
  $("body .tbbanner-right").owlCarousel({
    items: 2, //1 items above 1000px browser width
    nav: true,
    rtl: true,
    loop: true,
    autoplay: true,
    dots: false,
    responsive: {
      100: {
        items: 1,
      },
      481: {
        items: 2,
      },
      992: {
        items: 2,
      },
      1200: {
        items: 2,
      },
    },
  });
  $("body:not(.rtl) .offer_cms_slider").owlCarousel({
    nav: true,
    dots: false,
    autoplay: true,
    rewind: true,
    responsive: {
      100: {
        items: 1,
      },
      481: {
        items: 2,
      },
      768: {
        items: 2,
      },
      992: {
        items: 2,
      },
      1200: {
        items: 3,
      },
    },
  });
  $("body.rtl .offer_cms_slider").owlCarousel({
    nav: true,
    rtl: true,
    rewind: true,
    autoplay: true,
    dots: false,
    responsive: {
      100: {
        items: 1,
      },
      481: {
        items: 2,
      },
      768: {
        items: 2,
      },
      992: {
        items: 2,
      },
      1200: {
        items: 3,
      },
    },
  });
  $(".cmsoffer").each(function () {
    if ($(this).find(".owl-nav").hasClass("disabled")) {
      $(this).find(".customNavigation").hide();
    } else {
      $(this).find(".customNavigation").show();
    }
  });
  $(".cmsoffer .customNavigation .next").click(function () {
    var wrap = $(this).closest(".cmsoffer");
    $(wrap).find(".offer_cms_slider").trigger("next.owl");
  });
  $(".cmsoffer .customNavigation .prev").click(function () {
    var wrap = $(this).closest(".cmsoffer");
    $(wrap).find(".offer_cms_slider").trigger("prev.owl");
  });

  var banner = $("#cmsgallery .gallery-right");
  banner.owlCarousel({
    items: 2, //10 items above 1000px browser width
    dots: false,
    loop: false,
    nav: true,
    rewind: false,
    autoplay: false,
    responsive: {
      100: {
        items: 1,
      },
      481: {
        items: 2,
      },
      992: {
        items: 2,
      },
      1200: {
        items: 2,
      },
      1300: {
        items: 2,
      },
    },
  });

  var banner = $(".cmsvideo .tbvideoblock .image-block");
  banner.owlCarousel({
    items: 1, //10 items above 1000px browser width
    dots: false,
    loop: true,
    nav: false,
    rewind: true,
    autoplay: true,
    responsive: {
      100: {
        items: 1,
      },
      481: {
        items: 1,
      },
      992: {
        items: 1,
      },
      1200: {
        items: 1,
      },
      1300: {
        items: 1,
      },
    },
  });

  var banner = $(".product-thumb .slider-nav");
  banner.owlCarousel({
    items: 1, //10 items above 1000px browser width
    dots: false,
    loop: true,
    nav: true,
    rewind: true,
    autoplay: true,
    autoplayHoverPause: true,
    responsive: {
      100: {
        items: 1,
      },
      481: {
        items: 1,
      },
      992: {
        items: 1,
      },
      1200: {
        items: 1,
      },
      1300: {
        items: 1,
      },
    },
  });

  $("body:not(.rtl) #tb-megamenu .list_product_menu_content").owlCarousel({
    items: 3, //1 items above 1000px browser width
    nav: true,
    autoPlay: true,
    autoplaySpeed: 1000,
    stopOnHover: false,
    loop: false,
    dots: true,
    responsive: {
      768: {
        items: 3,
      },
      481: {
        items: 2,
      },
      100: {
        items: 1,
      },
    },
  });
  $("body.rtl #tb-megamenu .list_product_menu_content").owlCarousel({
    items: 3, //1 items above 1000px browser width
    nav: true,
    autoPlay: true,
    autoplaySpeed: 1000,
    rtl: true,
    stopOnHover: false,
    loop: false,
    dots: true,
    responsive: {
      768: {
        items: 3,
      },
      481: {
        items: 2,
      },
      100: {
        items: 1,
      },
    },
  });
  $(".full_gallery_slider.owl-carousel").on(
    "changed.owl.carousel",
    function (e) {
      console.log(e);
      var element = e.target; // DOM element, in this example .owl-carousel
      var items = e.item.count; // Number of items
      var item = e.relatedTarget.relative(e.item.index) + 1;

      console.log(e.relatedTarget.relative);

      $(element)
        .parent()
        .find(".num")
        .html(item + "/" + items);
    }
  ),
    $("body:not(.rtl) .full_gallery_slider.owl-carousel").owlCarousel({
      stagePadding: 200,
      loop: true,
      startPosition: 0,
      center: true,
      dots: true,
      items: 2,
      lazyLoad: true,
      nav: false,
      responsive: {
        0: {
          items: 1,
          stagePadding: 60,
        },
        600: {
          items: 1,
          stagePadding: 150,
        },
        768: {
          items: 1,
          stagePadding: 180,
        },
        868: {
          items: 1,
          stagePadding: 250,
        },
        1800: {
          items: 2,
          stagePadding: 300,
        },
      },
    });
  $("body.rtl .full_gallery_slider.owl-carousel").owlCarousel({
    stagePadding: 200,
    loop: true,
    startPosition: 0,
    center: true,
    dots: true,
    items: 2,
    rtl: true,
    lazyLoad: true,
    nav: false,
    responsive: {
      0: {
        items: 1,
        stagePadding: 60,
      },
      600: {
        items: 1,
        stagePadding: 150,
      },
      768: {
        items: 1,
        stagePadding: 180,
      },
      868: {
        items: 1,
        stagePadding: 250,
      },
      1800: {
        items: 2,
        stagePadding: 300,
      },
    },
  });
  // $(".dt-menu-expand").click(function (event) {
  //   event.preventDefault();
  //   if ($(this).hasClass("dt-mean-clicked")) {
  //     $(this).text("+");
  //     if ($(this).prev("ul").length) {
  //       $(this).prev("ul").slideUp(400);
  //     } else {
  //       $(this).prev(".megamenu-child-container").find("ul:first").slideUp(600);
  //     }
  //   } else {
  //     $(this).text("-");
  //     if ($(this).prev("ul").length) {
  //       $(this).prev("ul").slideDown(400);
  //     } else {
  //       $(this)
  //         .prev(".megamenu-child-container")
  //         .find("ul:first")
  //         .slideDown(2000);
  //     }
  //   }

  //   $(this).toggleClass("dt-mean-clicked");
  //   return false;
  // });
  $(document).on("click", ".collection_sidebar .dt-menu-expand", function (e) {
    e.preventDefault();
    const $this = $(this);
    const $ul = $this.next("ul");

    if ($this.hasClass("dt-mean-clicked")) {
      $this.text("+");
      $ul.stop(true, true).slideUp(400);
    } else {
      $this.text("-");
      $ul.stop(true, true).slideDown(400);
    }

    $this.toggleClass("dt-mean-clicked");
  });
  $("body:not(.rtl) .tb-testimonial-wrap .testimonials_wrap").owlCarousel({
    items: 1, //1 items above 1000px browser width
    nav: false,
    dots: true,
    loop: true,
    autoplay: true,
    autoplayHoverPause: true,
    responsive: {
      1279: {
        items: 1,
      },
      1250: {
        items: 1,
      },
      600: {
        items: 1,
      },
    },
  });
  $("body.rtl .tb-testimonial-wrap .testimonials_wrap").owlCarousel({
    items: 1, //1 items above 1000px browser width
    nav: false,
    rtl: true,
    dots: true,
    autoplay: true,
    loop: true,
    autoplayHoverPause: true,
    responsive: {
      1279: {
        items: 1,
      },
      1250: {
        items: 1,
      },
      600: {
        items: 1,
      },
    },
  });
  $("body:not(.rtl) .collection_cms_slider").owlCarousel({
    nav: true,
    dots: false,
    autoplay: true,
    rewind: true,
    responsive: {
      100: {
        items: 1,
      },
      481: {
        items: 2,
      },
      768: {
        items: 3,
      },
      992: {
        items: 3,
      },
      1200: {
        items: 3,
      },
    },
  });
  $("body.rtl .collection_cms_slider").owlCarousel({
    nav: true,
    rtl: true,
    rewind: true,
    autoplay: true,
    dots: false,
    responsive: {
      100: {
        items: 1,
      },
      481: {
        items: 2,
      },
      768: {
        items: 3,
      },
      992: {
        items: 3,
      },
      1200: {
        items: 3,
      },
    },
  });

  if (jQuery(".collection_cms_slider .owl-nav").hasClass("disabled")) {
    jQuery(".collection_cms_slider_wrap .customNavigation").hide();
  } else {
    jQuery(".collection_cms_slider_wrap .customNavigation").show();
  }
  jQuery(".collection_cms_slider_wrap .customNavigation .next").click(
    function () {
      jQuery(".collection_cms_slider_wrap .collection_cms_slider").trigger(
        "next.owl"
      );
    }
  );
  jQuery(".collection_cms_slider_wrap .customNavigation .prev").click(
    function () {
      jQuery(".collection_cms_slider_wrap .collection_cms_slider").trigger(
        "prev.owl"
      );
    }
  );
  $("body:not(.rtl) .widget_top_rated_products .top-products").owlCarousel({
    items: 1, //1 items above 1000px browser width
    nav: true,
    dots: true,
    loop: true,
    autoplay: true,
    rtl: false,
    responsive: {
      1279: {
        items: 1,
      },
      1250: {
        items: 1,
      },
      600: {
        items: 1,
      },
    },
  });
  $("body.rtl .widget_top_rated_products .top-products").owlCarousel({
    items: 1, //1 items above 1000px browser width
    nav: true,
    dots: true,
    loop: true,
    autoplay: true,
    rtl: true,
    responsive: {
      1279: {
        items: 1,
      },
      1250: {
        items: 1,
      },
      600: {
        items: 1,
      },
    },
  });

  jQuery(".spr-summary-actions-newreview").on("click", function (e) {
    e.preventDefault();
    jQuery(".spr-content").slideToggle("slow");
  });
});

var p = jQuery(".popup_overlay");

jQuery(".play-icone").click(function () {
  jQuery("body").addClass("popup-toggle");
  p.css("display", "block");
});
p.click(function (event) {
  e = event || window.event;
  if (e.target == this) {
    jQuery(p).css("display", "none");
    jQuery("body").removeClass("popup-toggle");
  }
});
jQuery(".popup_close,.flex-direction-nav li a").click(function () {
  p.css("display", "none");
  jQuery("body").removeClass("popup-toggle");
});

//video popup
function toggleVideo(state) {
  // if state == 'hide', hide. Else: show video
  e = state || window.event;
  if (e.target == this) {
    var div = document.getElementById("popupVid");
    var iframe = div.getElementsByTagName("iframe")[0].contentWindow;
    //div.style.display = state == 'hide' ? 'none' : '';
    func = state == "hide" ? "pauseVideo" : "playVideo";
    iframe.postMessage(
      '{"event":"command","func":"' + func + '","args":""}',
      "*"
    );
  }
}

jQuery("#popup_toggle").click(function () {
  p.css("visibility", "visible").css("opacity", "1");
});

p.click(function (event) {
  e = event || window.event;
  if (e.target == this) {
    jQuery(p).css("visibility", "hidden").css("opacity", "0");
    toggleVideo("hide");
  }
});

jQuery(".popup_close,.flex-direction-nav li a").click(function () {
  p.css("visibility", "hidden").css("opacity", "0");
  toggleVideo("hide");
});

var iframe = jQuery("iframe")[0];

jQuery(document).ready(function () {
  jQuery(".countdown-container.flip-countdown").css("display", "block");
});
// function megaMenu(){
//   if(jQuery(window).width() < 992) {
//     jQuery('body:not(.rtl) .header_2 #tb-megamenu .tb_menus_ul>.tb_menu_item>.tb_sub_menu_wrap').each(function() {
//       jQuery(this).css('margin-left', + (0) + 'px');
//     });
//     jQuery('body.rtl .header_2 #tb-megamenu .tb_menus_ul>.tb_menu_item>.tb_sub_menu_wrap').each(function() {
//       jQuery(this).css('margin-right', + (0) + 'px');
//     });
//   }
//   else{
//     jQuery('body:not(.rtl) .header_2 .menu_wrapper #tb-megamenu .tb_menus_ul>.tb_menu_item>.tb_sub_menu_wrap').each(function() {
//       var menu = jQuery('.main-header').offset();
//       var dropdown = jQuery(this).parent().offset();
//       var i = (dropdown.left + jQuery(this).outerWidth()) - (menu.left + jQuery('.main-header').outerWidth());
//       if (i > 0) {
//         jQuery(this).css('margin-left', '-' + (i + 10) + 'px');
//       }
//     });
//     jQuery('body.rtl .header_2 .menu_wrapper #tb-megamenu .tb_menus_ul>.tb_menu_item>.tb_sub_menu_wrap').each(function() {
//       var menu = jQuery('.main-header').offset();
//       var dropdown = jQuery(this).parent().offset();
//       var i = (dropdown.left + jQuery(this).outerWidth()) - (menu.left + jQuery('.main-header').outerWidth());
//       if (i > 0) {
//         jQuery(this).css('margin-right', '-' + (i + 10) + 'px');
//       }
//     });
//   }
// }
// jQuery(document).ready(function() {
//   megaMenu();
// });
// jQuery(window).resize(function() {
//   megaMenu();
// });

function megaMenu() {
  if (jQuery(window).width() < 992) {
    jQuery(
      "body:not(.rtl) .header_2 #tb-megamenu .tb_menus_ul>.tb_menu_item>.tb_sub_menu_wrap"
    ).css("margin-left", "");
    jQuery(
      "body.rtl .header_2 #tb-megamenu .tb_menus_ul>.tb_menu_item>.tb_sub_menu_wrap"
    ).css("margin-right", "");
  } else {
    jQuery(
      "body:not(.rtl) .header_2 .menu_wrapper #tb-megamenu .tb_menus_ul>.tb_menu_item>.tb_sub_menu_wrap"
    ).each(function () {
      var menu = jQuery(".main-header").offset();
      var dropdown = jQuery(this).parent().offset();
      var i =
        dropdown.left +
        jQuery(this).outerWidth() -
        (menu.left + jQuery(".main-header").outerWidth());
      if (i > 0) {
        jQuery(this).css("margin-left", "-" + (i + 10) + "px");
      } else {
        jQuery(this).css("margin-left", "");
      }
    });

    jQuery(
      "body.rtl .header_2 .menu_wrapper #tb-megamenu .tb_menus_ul>.tb_menu_item>.tb_sub_menu_wrap"
    ).each(function () {
      var menu = jQuery(".main-header").offset();
      var dropdown = jQuery(this).parent().offset();
      var i =
        dropdown.left +
        jQuery(this).outerWidth() -
        (menu.left + jQuery(".main-header").outerWidth());
      if (i > 0) {
        jQuery(this).css("margin-right", "-" + (i + 10) + "px");
      } else {
        jQuery(this).css("margin-right", "");
      }
    });
  }
}

let resizeTimer;
jQuery(window).resize(function () {
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(function () {
    megaMenu();
  }, 200); // Debounce the function
});

/*--------- Start js for menu-left-right -------------*/

jQuery(window).scroll(function () {
  if (jQuery(document).height() > jQuery(window).height()) {
    var scroll = jQuery(window).scrollTop();
    if (scroll > 100) {
      jQuery("#GotoTop").fadeIn();
    } else {
      jQuery("#GotoTop").fadeOut();
    }
  }
});

function responsiveMenu() {
  if (jQuery(window).width() < 992) {
    jQuery("#shopify-section-TB-megamenu").insertAfter(".nav-toggle");
    jQuery(".sub-nav__dropdown").css("display", "none");
    jQuery(".header_3 #top").insertBefore(".header-Top");
    jQuery(".header_3 .header-top-right").appendTo(".tb-mega_menu");
  } else {
    jQuery(".header_style_2 #shopify-section-TB-megamenu").prependTo(
      ".header_2 .menu_wrapper"
    );
    jQuery(".header_style_1 #shopify-section-TB-megamenu").appendTo(
      ".header_1_wrapper"
    );
    jQuery(".header_style_3 #shopify-section-TB-megamenu").prependTo(
      "#shopify-section-tb-megamenu"
    );
    jQuery(".header_3 #top").prependTo(".Top-nav");
    jQuery(".header_3 .header-top-right").appendTo("#top");
  }
}

jQuery(document).ready(function () {
  responsiveMenu();

  jQuery(".product-write-review").on("click", function (e) {
    e.preventDefault();
    $("a[href='#tab-2']").trigger("click");
    jQuery("html, body").animate(
      {
        scrollTop: jQuery(".product_tab_wrapper").offset().top - 150,
      },
      1000
    );
  });
});
jQuery(document).load(function () {
  //var menu_wrapper = jQuery('.menu_wrapper.logo_left').height();
});
jQuery(window).resize(function () {
  responsiveMenu();
  var w_width = $(window).width();
  $(".slider-content-main-wrap").css("width", w_width);
});

function footerToggle() {
  if (jQuery(window).width() < 992) {
    if (jQuery(".site-footer").hasClass("fixed_footer")) {
      jQuery(".page-wrapper").css("margin-bottom", "0px");
    }
    jQuery(".left-sidebar.sidebar").insertAfter(".collection_wrapper");
    jQuery(".left-sidebar.sidebar").insertAfter(".content-wrapper");
    jQuery(".collection_wrapper").append(jQuery(".sidebar-block"));
    jQuery(".sidebar-block").insertBefore("#ProductGridContainer");
    jQuery(".site-footer .footer-column h5").addClass("toggle");
    jQuery(".site-footer .footer-column")
      .children(":nth-child(2)")
      .css("display", "none");
    jQuery(".site-footer .footer-column.active")
      .children(":nth-child(2)")
      .css("display", "block");
    jQuery(".site-footer .footer-column h5.toggle").unbind("click");
    jQuery(".site-footer .footer-column h5.toggle").on("click", function () {
      jQuery(this)
        .parent()
        .toggleClass("active")
        .children(":nth-child(2)")
        .slideToggle("fast");
    });
    jQuery(
      ".right-sidebar.sidebar .widget > h4,.left-sidebar.sidebar .widget > h4,.blog-section .sidebar .widget > h4"
    ).addClass("toggle");
    jQuery(
      ".right-sidebar.sidebar .widget,.left-sidebar.sidebar .widget,.blog-section .sidebar .widget"
    )
      .children(":nth-child(2)")
      .css("display", "none");
    jQuery(
      ".right-sidebar.sidebar .widget.active,.left-sidebar.sidebar .widget.active,.blog-section .sidebar .widget.active"
    )
      .children(":nth-child(2)")
      .css("display", "block");
    jQuery(
      ".right-sidebar.sidebar .widget > h4.toggle,.left-sidebar.sidebar .widget > h4.toggle,.blog-section .sidebar .widget > h4.toggle"
    ).unbind("click");
    jQuery(
      ".right-sidebar.sidebar .widget > h4.toggle,.left-sidebar.sidebar .widget > h4.toggle,.blog-section .sidebar .widget > h4.toggle"
    ).on("click", function () {
      jQuery(this)
        .parent()
        .toggleClass("active")
        .children(":nth-child(2)")
        .slideToggle("fast");
    });
    jQuery(
      ".collection_right .sidebar-block .widget > h4,.collection_left .sidebar-block .widget > h4,.filter-toggle-wrap .sidebar-block .widget > h4"
    ).addClass("toggle");
    jQuery(
      ".collection_right .sidebar-block .widget,.collection_left .sidebar-block .widget,.filter-toggle-wrap .sidebar-block .widget "
    )
      .children(":nth-child(2)")
      .css("display", "none");
    jQuery(
      ".collection_right .sidebar-block .widget.active,.collection_left .sidebar-block .widget.active,.filter-toggle-wrap .sidebar-block .widget.active"
    )
      .children(":nth-child(2)")
      .css("display", "block");
    jQuery(
      ".collection_right .sidebar-block .widget > h4.toggle,.collection_left .sidebar-block .widget > h4.toggle,.filter-toggle-wrap .sidebar-block .widget > h4.toggle"
    ).unbind("click");
    jQuery(
      ".collection_right .sidebar-block .widget > h4.toggle,.collection_left .sidebar-block .widget > h4.toggle,.filter-toggle-wrap .sidebar-block .widget > h4.toggle"
    ).on("click", function () {
      jQuery(this)
        .parent()
        .toggleClass("active")
        .children(":nth-child(2)")
        .slideToggle("fast");
    });
  } else {
    jQuery(".sidebar-block").prependTo(".collection_sidebar");
    if (jQuery(".site-footer").hasClass("fixed_footer")) {
      var footer_h = jQuery(".site-footer.fixed_footer").height();
      jQuery(".page-wrapper").css("margin-bottom", footer_h + "px");
    }
    jQuery(".left-sidebar.sidebar").insertBefore(".collection_wrapper");
    jQuery(".sidebar .widget > h4,.sidebar-block .widget > h4").unbind("click");
    jQuery(".sidebar .widget > h4,.sidebar-block .widget > h4").removeClass(
      "toggle"
    );
    jQuery(".sidebar .widget,.sidebar-block .widget")
      .children(":nth-child(2)")
      .css("display", "block");

    jQuery(".site-footer .footer-column h5").unbind("click");
    jQuery(".site-footer .footer-column h5").removeClass("toggle");
    jQuery(".site-footer .footer-column")
      .children(":nth-child(2)")
      .css("display", "block");
  }
  if (jQuery(window).width() < 767) {
    $(".lookbook_wrap_item").each(function (i) {
      var app_div = jQuery(this).find(".grid-img-wrap");
      jQuery(this).find(".lookbook-content.text-center").insertAfter(app_div);
    });
  } else {
    $(".lookbook_wrap_item").each(function (i) {
      var app_div = jQuery(this);
      jQuery(this).find(".lookbook-content.text-center").prependTo(app_div);
    });
  }
}
jQuery(document).ready(function () {
  footerToggle();
  /*sidebarsticky();*/
});
jQuery(window).resize(function () {
  footerToggle();
});

function height() {
  var maxHeight = $(
    ".design_3 .product-block .product-img .image,.design_2 .product-block .image,.design_1 .product-single__thumbs a.product-single__thumbnail img"
  ).height();
  $(
    ".design_3 .product-block .product-img .extra-video,.design_2 .product-block .extra-video,.design_1 .product-single__thumbs a.product-single__thumbnail.extra-video img"
  ).height(maxHeight);
  $(
    ".design_3 .product-block .product-img .video,.design_2 .product-block .video,.design_1 .product-single__thumbs a.product-single__thumbnail.video img"
  ).height(maxHeight);
  $(
    ".design_3 .product-block .product-img .model,.design_2 .product-block .model,.design_1 .product-single__thumbs a.product-single__thumbnail.model img"
  ).height(maxHeight);
}
$(document).ready(function () {
  height();
});
$(window).resize(function () {
  height();
});
$(window).scroll(function () {
  height();
});

function productcartsticky() {
  if (jQuery(window).width() > 319) {
    if (jQuery(this).scrollTop() > 550) {
      jQuery(".add-to-cart-sticky").addClass("fixed");
    } else {
      jQuery(".add-to-cart-sticky").removeClass("fixed");
    }
  } else {
    jQuery(".add-to-cart-sticky").removeClass("fixed");
  }
}

$(document).ready(function () {
  productcartsticky();
});
jQuery(window).resize(function () {
  productcartsticky();
});
jQuery(window).scroll(function () {
  productcartsticky();
});

function splitStr(string, seperator) {
  return string.split(seperator);
}

function countDownIni(countdown) {
  $(countdown).each(function () {
    var countdown = $(this);
    var promoperiod;
    if (countdown.attr("data-promoperiod")) {
      promoperiod =
        new Date().getTime() + parseInt(countdown.attr("data-promoperiod"), 10);
    } else if (countdown.attr("data-countdown")) {
      promoperiod = countdown.attr("data-countdown");
    }
    if (Date.parse(promoperiod) - Date.parse(new Date()) > 0) {
      $(this).addClass("countdown-block");
      $(this).parent().addClass("countdown-enable");
      console.log();
      countdown.countdown(promoperiod, function (event) {
        countdown.html(
          event.strftime(
            '<span><span class="left-txt">LEFT</span><span>%D</span><span class="time-txt">days</span></span>' +
              '<span><span>%H</span><span class="time-txt">hours</span></span>' +
              '<span><span>%M</span><span class="time-txt">min</span></span>' +
              '<span><span class="second">%S</span><span class="time-txt">sec</span></span>'
          )
        );
      });
    }
  });
}

function hb_animated_contents() {
  $(".hb-animate-element:in-viewport").each(function (i) {
    var $this = $(this);
    if (!$this.hasClass("hb-in-viewport")) {
      setTimeout(function () {
        $this.addClass("hb-in-viewport");
      }, 180 * i);
    }
  });
}

$(window).scroll(function () {
  hb_animated_contents();
});
$(window).load(function () {
  hb_animated_contents();
});

function sidebarsticky() {
  if ($(document).width() <= 1199) {
    jQuery(
      ".left-sidebar.sidebar,.right-sidebar.sidebar.collection_right,.collection_left"
    ).theiaStickySidebar({
      additionalMarginBottom: 30,
      additionalMarginTop: 30,
    });
  } else if ($(document).width() >= 1200) {
    jQuery(
      ".left-sidebar.sidebar,.right-sidebar.sidebar,.collection_right,.collection_left"
    ).theiaStickySidebar({
      additionalMarginBottom: 30,
      additionalMarginTop: 130,
    });
  }
}
jQuery(document).ready(function () {
  sidebarsticky();
});
jQuery(window).resize(function () {
  sidebarsticky();
});
/* responsive accordian menu*/
$(function () {
  var Accordion = function (el, multiple) {
    this.el = el || {};
    this.multiple = multiple || false;

    // Variables privadas
    var links = this.el.find("li.tb_mm_hassub .mobile-nav__sublist-trigger");
    // Evento
    links.on("click", { el: this.el, multiple: this.multiple }, this.dropdown);
  };

  Accordion.prototype.dropdown = function (e) {
    var $el = e.data.el;
    ($this = $(this)), ($next = $this.next());

    $next.slideToggle();
    $this.parent().toggleClass("open");

    if (!e.data.multiple) {
      $el
        .find("li.tb_mm_hassub .tb_sub_menu_wrap")
        .not($next)
        .slideUp()
        .parent()
        .removeClass("open");
    }
  };

  var accordion = new Accordion($(".tb_menus_ul"), false);
});

// ================= Add Common-Home Class On Body Tag =================
document.addEventListener("DOMContentLoaded", function () {
  // Check if the element with ID 'tb-home-slideshow' exists
  var slideshowElement = document.getElementById("tb-home-slideshow");

  if (slideshowElement) {
    // If the element is found, add the class 'common-home' to the body tag
    document.body.classList.add("common-home");
  }
});

// ================= Header 1 Menu Width =================
document.addEventListener("DOMContentLoaded", function () {
  // Function to set the width of tb-megamenu
  function setMegamenuWidth() {
    if (window.innerWidth >= 992) {
      // Get the width of the menu logo
      var menuLogo = document.querySelector(".header_style_1 .menu-logo");
      if (menuLogo) {
        var menuLogoWidth = menuLogo.offsetWidth;

        // Set the width to the tb-megamenu
        var tbMegamenu = document.querySelector(
          ".header_style_1 .page-wrapper #tb-megamenu"
        );
        if (tbMegamenu) {
          tbMegamenu.style.width = menuLogoWidth + "px";
        }
      }
    } else {
      // Optionally, reset the width for smaller screens
      var tbMegamenu = document.querySelector(
        ".header_style_1 .page-wrapper #tb-megamenu"
      );
      if (tbMegamenu) {
        tbMegamenu.style.width = ""; // Resets the width
      }
    }
  }

  // Initial call to set the width
  setMegamenuWidth();

  // Add an event listener to handle window resize
  window.addEventListener("resize", setMegamenuWidth);
});
